import $ from 'jquery';
import anime from 'animejs/lib/anime';
import inView from 'in-view';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

$(function() {
    // Reset all others panels
    function resetPanels() {
        anime({
            targets: '.expanded .block-featured-panel-infos',
            translateY: ['0%', '100%'],
            easing: 'spring(1, 60, 10, 0)',
        });
        anime({
            targets: '.expanded .btn-see-more',
            top: '87%',
            rotate: '0deg',
            easing: 'spring(1, 60, 10, 0)',
        });
        $('.expanded .btn-see-more').removeClass('open');
    }

    if ($('body').hasClass('realisations')) {
        gsap.registerPlugin(ScrollToPlugin);
        gsap.to(window, { duration: 0.5, scrollTo: '.hero-realisation' });
        // Hero
        inView('.hero-realisation').once('enter', function () {
            anime({
                targets: ['.hero-text h1', '.hero-text .hero-infos div'],
                translateY: ['65%', '0%'],
                opacity: ['0', '100%'],
                delay: anime.stagger(200, { start: 500 }),
                easing: 'spring(1, 60, 10, 0)',
            });
        }, {
            threshold: 1,
        });

        // Block featured panels
        $('.block-featured-panels').each(function () {
            $('.block-featured-panel').each(function (i, el) {
                const $element = $(el);
                const $button = $element.find('.btn-see-more', el);
                $($button).on('click', function () {
                    const isOpen = $(this).hasClass('open');
                    // Reset all others panels
                    resetPanels();
                    // Animate selected panel
                    if (!isOpen) {
                        anime({
                            targets: $('.block-featured-panel-infos', $element)[0],
                            translateY: ['100%', '0%'],
                            easing: 'spring(1, 60, 10, 0)',
                        });
                        anime({
                            targets: $button[0],
                            top: '5%',
                            rotate: '45deg',
                            easing: 'spring(.8, 60, 10, 0)',
                        });
                        $(this).addClass('open');
                        $element.removeClass('dimmed');
                        $element.addClass('expanded');
                        // Managing other panels
                        $('.block-featured-panel').not($element).addClass('dimmed').removeClass('expanded');
                        // Change hidden text
                        $('span', $button).text($($('span', $button)).attr('data-moins'));
                    } else {
                        anime({
                            targets: $('.block-featured-panel-infos', $element)[0],
                            translateY: ['0%', '100%'],
                            easing: 'spring(1, 60, 10, 0)',
                        });
                        anime({
                            targets: $button[0],
                            top: window.innerWidth > 768 ? '87%' : '81.5%',
                            rotate: '0deg',
                            easing: 'spring(.8, 60, 10, 0)',
                        });
                        $(this).removeClass('open');
                        $element.removeClass('dimmed');
                        $element.addClass('expanded');
                        // Managing other panels
                        $('.block-featured-panel').removeClass('dimmed expanded');
                        // Change hidden text
                        $('span', $button).text($($('span', $button)).attr('data-plus'));
                    }
                });
            });
        });

        $(document).on('click', (e) => {
            if (!$('.btn-see-more').is(e.target) && !$('.btn-see-more').has(e.target).length) {
                resetPanels();
                $('.btn-see-more').removeClass('open');
                $('.block-featured-panel').removeClass('expanded dimmed');
            }
        });

        // block-realisations-functionality
        inView('.block-realisations-functionality').once('enter', function () {
            anime({
                targets: '.functionality-item',
                translateY: ['50%', '0%'],
                opacity: ['0', '100%'],
                delay: anime.stagger(200, { start: 500 }),
                easing: 'spring(1, 60, 10, 0)',
            });
        }, {
            threshold: 0.8,
        });

        // block-text-realisations
        inView('.block-text-realisations').once('enter', function () {
            anime({
                targets: '.block-text-realisations .column',
                translateY: ['65%', '0%'],
                opacity: ['0', '100%'],
                delay: anime.stagger(200, { start: 500 }),
                easing: 'spring(1, 60, 10, 0)',
            });
        }, {
            threshold: 0.8,
        });

        // block-realisations-img-text
        inView('.block-realisations-img-text').once('enter', function () {
            anime({
                targets: ['.block-realisations-img-text .img-wrapper', '.block-realisations-img-text .text-wrapper'],
                translateY: ['65%', '0%'],
                opacity: ['0', '100%'],
                delay: anime.stagger(200, { start: 500 }),
                easing: 'spring(1, 60, 10, 0)',
            });
        }, {
            threshold: 0.8,
        });

        // block-realisations-contact
        inView('.block-realisations-contact').once('enter', function () {
            anime({
                targets: ['.block-realisations-contact-infos svg', '.block-realisations-contact-infos h2', '.block-realisations-contact-infos p', '.block-realisations-contact-infos a'],
                translateY: ['65%', '0%'],
                opacity: ['0', '100%'],
                delay: anime.stagger(200, { start: 500 }),
                easing: 'spring(1, 60, 10, 0)',
            });
        }, {
            threshold: 1,
        });

        // block-img-gradient
        inView('.block-img-gradient').once('enter', function () {
            anime({
                targets: ['.block-img-gradient h2', '.block-img-gradient p'],
                translateY: ['65%', '0%'],
                opacity: ['0', '100%'],
                delay: anime.stagger(200, { start: 500 }),
                easing: 'spring(1, 60, 10, 0)',
            });
        }, {
            threshold: 0.8,
        });
    }
});
